import { useNavigate } from '@tanstack/react-router';
import { metaMask } from '@wagmi/connectors';
import { connect } from '@wagmi/core';
import { toast } from '@workspace/ui/components/sonner';
import { useCallback } from 'react';

import { config } from '~/config/wagmi';
import type { OriginName } from '~/interfaces/common';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '~/utils/local-storage';
import { checkAliasesAvailability, fetchAuthRegistration } from '../-api/api';
import type { AccountProfileData } from '../-types/types';

export function useSignupForm() {
  const navigate = useNavigate();

  const createAccount = useCallback(
    async (
      namespace: OriginName,
      provider: string,
      data: AccountProfileData,
    ) => {
      const res = await checkAliasesAvailability(data.email);
      if (res?.alias) {
        toast.error('El correo electrónico ya existe');
        return;
      }

      setLocalStorageItem('signup', data);
      setLocalStorageItem('originName', namespace);
      setLocalStorageItem('authFlow', 'signup');

      const redirect = getLocalStorageItem<string>('redirect') || '/';

      if (provider === 'whatsapp') {
        const phone = data.phone || '';

        await fetchAuthRegistration(namespace, phone);
        navigate({
          to: '/auth/otp/$origin-name',
          params: { 'origin-name': 'whatsapp' },
          search: { alias: phone, redirect },
        });
        return;
      }

      if (provider === 'email') {
        const email = data.email;

        await fetchAuthRegistration(namespace, email);
        navigate({
          to: '/auth/otp/$origin-name',
          params: { 'origin-name': 'email' },
          search: { alias: email, redirect },
        });
        return;
      }

      if (provider === 'MetaMask') {
        await connect(config, { connector: metaMask() });
        return;
      }
    },
    [navigate],
  );

  return {
    createAccount,
  };
}
